import { render, staticRenderFns } from "./ikm.vue?vue&type=template&id=5a5c1ea2"
import script from "./ikm.vue?vue&type=script&lang=js"
export * from "./ikm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QSeparator,QBtnGroup,QBtn,QTooltip,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QSeparator,QBtnGroup,QBtn,QTooltip,QDialog,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
